export default "__VITE_ASSET__Ddy6Mx0G__"